import React from 'react';
export var Heading = React.memo(function (_a) {
    var _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h2' : _b, heading = _a.heading, className = _a.className;
    var Heading = headingLevel;
    return React.createElement(Heading, { className: className, dangerouslySetInnerHTML: {
            __html: heading
        } });
});
